module.exports = __webpack_public_path__ + "media/images/talent/case1-icon02-9754ca77a24b60e76fe989b79e4f5abc.png";